import { InjectionToken } from '@angular/core';

/** Base URL for backend API (e.g. http://localhost:3000) */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');
